module.exports = __webpack_public_path__ + "static/media/purplerose3.1b8350fc.jpg";